import { format } from 'date-fns';

const PERIOD_RANGE_SEPARATOR = ' - ';

export function splitPeriodRangeString(periodDateString: string): [string, string] {
    const periodConstituents = periodDateString.split(PERIOD_RANGE_SEPARATOR);
    const startDateString = periodConstituents[0];
    const endDateString = periodConstituents.length === 2 ? periodConstituents[1] : periodConstituents[0];

    return [startDateString, endDateString];
}

export function joinPeriodRangeString(startDateString: string, endDateString: string): string {
    return `${startDateString}${PERIOD_RANGE_SEPARATOR}${endDateString}`;
}

export function parsePeriodRange(periodDateString: string): { startDate: Date; endDate: Date } {
    const [startDateString, endDateString] = splitPeriodRangeString(periodDateString);

    const startDate = new Date(Date.parse(startDateString));
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(Date.parse(endDateString));
    endDate.setHours(23, 59, 59, 999);

    return { startDate, endDate };
}

export function formatPeriodByDate(periodDateString: string): string {
    const { startDate, endDate } = parsePeriodRange(periodDateString);

    return `from=${format(startDate, 'yyyy-MM-dd')}&to=${format(endDate, 'yyyy-MM-dd')}`;
}
